import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  Row,
} from 'reactstrap';
import { ReactComponent as CorrectSign } from '../../assets/images/svg/correct-sign.svg';
import StyledButton from '../../components/Common/StyledButton';
import { formatNumberWithCommasAndDecimal } from '../Invoices/invoiceUtil';
// import { ReactComponent as Delete } from "../../assets/images/svg/delete-button.svg";
import { Cancel, CheckCircle, Print } from '@mui/icons-material';
import HistoryIcon from '@mui/icons-material/History';
import { connect } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import generatePDF, { Margin, Options, Resolution } from 'react-to-pdf';
import ApproveConfirm from '../../components/CustomComponents/ApproveConfirm';
import PublishConfirm from '../../components/CustomComponents/PublishConfirm';
import RequirePermission from '../../routes/middleware/requirePermission';
import RequireUserType from '../../routes/middleware/requireUserType';
import {
  convertToSalesOrderReq,
  getPurchaseOrderAuditDetailsReq,
  getPurchaseOrderDetailsReq,
  purchaseOrderStatusChangeReq,
} from '../../service/purchaseService';
import { setBreadcrumbItems } from '../../store/Breadcrumb/actions';
import {
  MODULES_ENUM,
  PERMISSIONS_ENUM,
  USER_TYPES_ENUM,
} from '../../utility/constants';
import OrderStatusRenderer from './OrderStatusRenderer';
// import { IconButton, Tooltip } from "@mui/material";
// import Hero from "../../components/Common/Hero";
import { toast } from 'react-toastify';
import { getAgreement } from '../../api';
import Spinners from '../../components/Common/Spinner';
import { formatDate } from '../../utility/formatDate';
import getPaymentTerm from '../../utility/getPaymentTerm';
import PdfComponent from './PdfComponent';
import RejectionReasonModal from '../../components/Common/RejectionModal';

const PurchaseOrderDetails = (props) => {
  const { id, version, auditId } = useParams();
  const isAuditTrail = !!version;
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [orderInfo, setOrderInfo] = useState({});
  const [auditOrderInfo, setAuditOrderInfo] = useState({});
  const [status, setStatus] = useState('');
  const [publishModal, setPublishModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("published");
  const [paymentTerms, setPaymentTerms] = useState()
  const [showWatermark, setShowWatermark] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reasonModal, setReasonModal] = useState(false);
  const [statusReason, setStatusReason] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);

  const statusToTextMap = {
    draft: 'Draft',
    published: 'Publish',
    sent: 'Approve',
    accepted: 'Accept',
    rejected: 'Reject',
    declined: 'Declined',
  };

  async function handlePurchaseOrderStatusChange(status, statusReason) {
    const body = {
      purchaseOrderId: id,
      status: status,
      statusReason: statusReason
    };
    setIsButtonLoading(true);
    if (status === 'accepted') {
      try {
        const response = await convertToSalesOrderReq({
          purchaseOrderId: body.purchaseOrderId,
        });
        if (response.success) {
          toast.success('Purchase order Accepted');
          setStatus(status);
        } else {
          const { message } = response;
          toast.error(message || 'Sorry, something went wrong!');
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error('Bad Request:', error);
          toast.error('Something went wrong');
          // Handle the 400 error here, e.g., show an error message to the user
        } else {
          console.error('Failed to convert to sales order', error);
          toast.error('Something went wrong');
        }
      } finally {
        setIsButtonLoading(false);
        setApproveModal(false);
      }
    } else {
      try {
        const response = await purchaseOrderStatusChangeReq(body);
        if (response.success) {
          toast.success(`Purchase Order ${statusToTextMap[status]}`)
          setStatus(status);
        } else {
          const { message } = response;
          toast.error(message || 'Sorry, something went wrong!');
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error('Bad Request:', error);
          toast.error('Something went wrong');
          // Handle the 400 error here, e.g., show an error message to the user
        } else {
          console.error('Failed to change purchase order status:', error);
          toast.error('Something went wrong');
        }
      } finally {
        setIsButtonLoading(false);
        setApproveModal(false);
      }
    }
  }

  const submitPurchaseOrder = () => {
    setSelectedStatus('sent');
    setApproveModal(true);
  };

  const rejectPurchaseOrder = () => {
    setSelectedStatus('rejected');
    setReasonModal(true)
    console.log('PURCHASE ORDER REJECTED');
  };

  const acceptPurchaseOrder = () => {
    setSelectedStatus('accepted');
    setApproveModal(true);
    //setStatus('accepted');
    //setSelectedStatus('accepted');
    //TODO: The handlePurchaseOrderStatusChange(); is taking the old value of selectedStatus
    //TODO: ADD BUTTON LOADER, IN THE BACKEND ADD ZOHO SYNC API CALL
  };

  const declinePurchaseOrder = () => {
    setSelectedStatus('declined');
    setReasonModal(true);
    setApproveModal(true)
  };
  const submitReason = () => {

    setReasonModal(false);

    handlePurchaseOrderStatusChange(
      selectedStatus,
      statusReason
    );

    setStatusReason("");
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    if (newStatus === 'published') {
      setPublishModal(true);
    }
  };

  const getAuditPurchaseOrderDetails = async () => {
    const response = await getPurchaseOrderDetailsReq(id);
    const rawData = response?.data;
    console.log(rawData)
    setAuditOrderInfo(rawData)
  };

  const getPurchaseOrderDetails = async () => {
    const response = isAuditTrail
      ? await getPurchaseOrderAuditDetailsReq(id, auditId)
      : await getPurchaseOrderDetailsReq(id);
    const rawData = response?.data;
    const purchaseOrder = isAuditTrail && rawData?.snapshot
      ? {
        ...rawData,
        ...(rawData.snapshot.purchaseOrderDetails || {}),
        items: rawData.snapshot.items || [],
      }
      : rawData;
    setItemsData(purchaseOrder?.items);
    setOrderInfo(purchaseOrder);
    setStatus(purchaseOrder?.POStatus);
    if (purchaseOrder?.POStatus !== 'draft') {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
    let totalAmount=0
    let totalIGST=0;
    let totalCGST=0;
    let totalSGST=0;
    let totalQuantity=0;

    (purchaseOrder.items||[]).forEach((item)=>{
      totalAmount+=item.unitPrice*item.quantity
      totalQuantity+=item.quantity
      item?.taxes.forEach((tax)=>{
        if(tax.name.includes("CGST"))
        {
          totalCGST+=(item.unitPrice*item.quantity*tax?.rate)/100;
        }
        if(tax.name.includes("SGST"))
        {
          totalSGST+=(item.unitPrice*item.quantity*tax?.rate)/100
        }
        if(tax.name.includes("IGST"))
        {
          totalIGST+=(item.unitPrice*item.quantity*tax?.rate)/100;
        }
      })
    })
    const grandTotal=totalAmount+totalCGST+totalSGST+totalIGST
    setOrderInfo({
      ...purchaseOrder,
      totalAmount,
      totalQuantity,
      totalCGST,
      totalSGST,
      totalIGST,
      grandTotal
    });

  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        await Promise.all([
          getAuditPurchaseOrderDetails(),
          getPurchaseOrderDetails(),
        ]);
      } catch (e) {
        console.error("Error fetching PO details", e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, version, auditId]);

  const getAgreementData = async (id) => {
    try {
      const data = { clientId: id }
      const res = await getAgreement(data);

      setPaymentTerms(res.payload.paymentTerms)
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    const poNumber = isAuditTrail
      ? auditOrderInfo?.purchaseOrderNumber
      : orderInfo?.purchaseOrderNumber;

    if (!poNumber) return;

    const breadcrumbItems = isAuditTrail
      ? [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Purchase Orders", link: "/purchase-orders" },
        {
          title: poNumber,
          link: `/purchase-orders/${id}/trail`,
        },
        { title: version, link: "#" },
      ]
      : [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Purchase Orders", link: "/purchase-orders" },
        { title: poNumber, link: "#" },
      ];

    props.setBreadcrumbItems("Purchase Order", breadcrumbItems);
  }, [orderInfo, auditOrderInfo, version, id]);

  useEffect(() => {
    if (orderInfo.clientId) {
      getAgreementData(orderInfo.clientId);
    }
  }, [orderInfo.clientId]);

  const options = {
    filename: 'Purchase Order.pdf',
    method: 'save',
    resolution: Resolution.HIGH,
    page: {
      margin: Margin.MEDIUM,
      format: 'A4',
      orientation: 'portrait',
    },
    canvas: {
      mimeType: 'image/jpeg',
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
      canvas: {
        useCORS: true,
      },
    },
  };

  const getTargetElement = () => document.getElementById("print-container");
  const downloadPDF = async () => {
    setShowWatermark(true);

    setTimeout(async () => {
      await generatePDF(getTargetElement, options);
      setShowWatermark(false);
    }, 300);
  };


  const billingAddress = orderInfo.billing?.address;
  const warehouseAddress = orderInfo.billing
  const shippingAddress = orderInfo.shipping?.address;

  const getAddressValue = (address) => {
    if (!address) return '';
    return (
      <>
        {address.addressLine1},<br />
        {address.addressLine2 || ''},<br />
        {address.state}&nbsp;{address.city}&nbsp;-&nbsp;{address.pincode}.
      </>
    );
  };
  const getOfficeAddress = (address) => {
    if (!address) return '';
    return (
      <>
        {address?.associatedwarehouse?.address?.addressLine1||"No. 1496, Opp. Park Square Apartment,"}<br />
        {address?.associatedwarehouse?.address?.addressLine2 ||"19th Main, 1st Sector, HSR Layout"},<br />
        {address?.associatedwarehouse?.address?.state||"Karnataka"}&nbsp;{address?.associatedwarehouse?.address?.city||"Bengaluru"}&nbsp;-&nbsp;
        {address?.associatedwarehouse?.address?.pincode||"560102"}.
      </>
    );
  };
  useEffect(() => {
    if (
      (orderInfo?.POStatus === "rejected"||orderInfo?.POStatus==="declined") &&
      orderInfo?.statusReason
    ) {
      setShowRejectModal(true);
    }
  }, [orderInfo]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <Spinners />
      </div>
    );
  }

  const getTaxRows = (orderInfo) => {
    const { totalCGST, totalSGST, totalIGST, grandTotal } = orderInfo;
    const rows = [];
    console.log("orderInfo",orderInfo)

    if (totalCGST > 0) rows.push({ label: 'CGST', value: totalCGST });
    if (totalSGST > 0) rows.push({ label: 'SGST', value: totalSGST });
    if (totalIGST > 0) rows.push({ label: 'IGST', value: totalIGST });

    rows.push({ label: 'Total', value: grandTotal });
    return rows;
  };

  return (
    <>
     <RejectionReasonModal
      isOpen={showRejectModal}
      toggle={() => setShowRejectModal(false)}
      reason={orderInfo?.statusReason}
      type='PO'
      status={orderInfo?.POStatus}
      />
      <div style={{ position: 'relative' }}>
        <div
          className="d-flex align-items-center gap-2"
          style={{
            position: 'fixed',
            top: 100,
            right: 10,
            zIndex: 1000
          }}
        >
          <Modal
            centered
            toggle={() => setPublishModal(!publishModal)}
            isOpen={publishModal}
          >
            <PublishConfirm
              setPublishModal={setPublishModal}
              setStatus={setStatus}
              id={id}
            />
          </Modal>
          <Modal
            centered
            toggle={() => setApproveModal(!approveModal)}
            isOpen={approveModal}
          >
            <ApproveConfirm
              setApproveModal={setApproveModal}
              handlePurchaseOrderStatusChange={handlePurchaseOrderStatusChange}
              status={selectedStatus}
              isButtonLoading={isButtonLoading}
            />
          </Modal>

          {status === 'draft' ? (
            <>
              <PdfComponent data={{ orderInfo, itemsData, paymentTerms }} />
              <select
                className="form-select focus-width"
                name="status"
                disabled={isDisabled}
                value={status}
                onChange={handleStatusChange}
              >
                <option value="draft">Draft</option>
                <option value="published">Published</option>
              </select>
              <Link to="edit" className="w-md btn btn-primary">
                Edit
              </Link>
            </>
          ) : (
            <>
              <span
                onClick={() => {
                  if (status?.toLowerCase() === "declined"||"rejected") {
                    setShowRejectModal(true);
                  }
                }}
                  style={{
                    cursor: status?.toLowerCase() === "rejected"||"declined" ? "pointer" : "default"
                  }}
                >
                {OrderStatusRenderer({ value: status })}
              </span>
              

              <RequirePermission
                module={MODULES_ENUM.ORDERS}
                permission={PERMISSIONS_ENUM.CREATE}
              >
                <div className="d-flex align-items-center gap-2">
                  {!isAuditTrail && <PdfComponent data={{ orderInfo, itemsData, paymentTerms }} />}

                  <Link
                    to={`/purchase-orders/${id}/trail`}
                    className="btn btn-outline-secondary d-flex align-items-center gap-1"
                  >
                    <HistoryIcon fontSize="small" />
                    History
                  </Link>
                </div>
              </RequirePermission>
            </>
          )}
          <Modal
            centered
            isOpen={reasonModal}
            toggle={() => setReasonModal(false)}
          >
            <div className="p-4">
              <h4 className="mb-3">
                {selectedStatus === "rejected"
                  ? "Reject Purchase Order"
                  : "Decline Purchase Order"}
              </h4>
              <div className="mb-3">
                <label className="form-label">
                  Reason <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Enter reason..."
                  value={statusReason}
                  onChange={(e) => setStatusReason(e.target.value)}
                />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <Button
                  color="secondary"
                  onClick={() => {
                    setReasonModal(false);
                    setStatusReason("");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  disabled={!statusReason.trim()}
                  onClick={submitReason}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Modal>
          <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              {!isAuditTrail && status === 'published' && (
                <StyledButton
                  color={'success'}
                  className={'w-md mx-2'}
                  onClick={submitPurchaseOrder}
                >
                  <CorrectSign className="me-1" />
                  Accept
                </StyledButton>)}
            </RequirePermission>
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
            <RequirePermission
              module={MODULES_ENUM.ORDERS}
              permission={PERMISSIONS_ENUM.CREATE}
            >
              {!isAuditTrail && status === 'published' && (
                <StyledButton
                  color={'danger'}
                  className={'w-md mx-2'}
                  onClick={rejectPurchaseOrder}>
                  <Cancel className="me-1" />
                  Decline
                </StyledButton>
              )}
            </RequirePermission>
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
            {!isAuditTrail && status === 'sent' && (
              <StyledButton
                color={'success'}
                className={'w-md'}
                onClick={acceptPurchaseOrder}
              >
                <CorrectSign className="me-1" />
                Accept
              </StyledButton>
            )}
          </RequireUserType>
          <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
            {!isAuditTrail && status === 'sent' && (
              <StyledButton
                color={'danger'}
                className={'w-md mx-2'}
                onClick={declinePurchaseOrder}
              >
                <Cancel className="me-1" />
                Decline
              </StyledButton>
            )}
          </RequireUserType>
        </div>
      </div>
      <div id="print-container" style={{ position: "relative" }}>
        {showWatermark && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%) rotate(-45deg)",
              transformOrigin: "center",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "80px",
              color: "rgba(150,150,150,0.2)",
              fontWeight: "bold",
              pointerEvents: "none",
              zIndex: 1000,
              whiteSpace: "nowrap",
            }}
          >
            {status?.toUpperCase()}
          </div>
        )}
        <Card>
          <CardBody>
            <div className="card-content">
              <div className="details">
                <h3 className="fw-bolder">{!isAuditTrail ? orderInfo.clientName : auditOrderInfo?.clientName}</h3>
                <p className="m-0">{orderInfo.billing?.branchName}</p>
                <p className="m-0">
                  <>{getAddressValue(billingAddress)}</>
                </p>
                <p className="m-0">{orderInfo.billing?.contact}</p>
              </div>
              <div>
                <span className="purchase-order">Purchase Order</span>
                <br />
                <span className="purchase-order-no">
                  {!isAuditTrail ? orderInfo.purchaseOrderNumber : auditOrderInfo?.purchaseOrderNumber}
                </span>
              </div>
            </div >
          </CardBody >
        </Card >

        <Row className="mb-3">
          <div style={{ position: 'relative' }}>
            <Row className="equal-height-cards">
              <Col xl="7">
                <Card>
                  <CardBody>
                    <Row className="py-2 border-bottom">
                      <Col>Order Date</Col>
                      <Col>{formatDate(!isAuditTrail ? orderInfo?.poDate : auditOrderInfo?.createdAt)}</Col>
                    </Row>
                    <Row className="py-2 border-bottom">
                      <Col>Payment Terms</Col>
                      <Col>{!isAuditTrail ? getPaymentTerm(paymentTerms) : '-'}</Col>
                    </Row>
                    <Row className="py-2 border-bottom">
                      <Col>Sales Order No.</Col>
                      <Col>
                        {orderInfo?.salesOrderNumber
                          ? orderInfo?.salesOrderNumber
                          : '-'}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="5">
                <Card>
                  <CardBody className="d-flex flex-column gap-2">
                    <div style={{ flex: 1 }} className="border-bottom">
                      <p className="fw-lighter m-0">Vendor Address</p>
                      <h5 className="fw-medium text-uppercase m-0">
                        <>
                        Bansi Office Solutions Private Limited<br/>
                        {getOfficeAddress(warehouseAddress)}
                        </>

                      </h5>
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className="fw-lighter m-0">Shipping Address</p>
                      <h5 className="fw-medium text-uppercase m-0">
                        <>{getAddressValue(shippingAddress)}</>
                      </h5 >
                    </div >
                  </CardBody >
                </Card >
              </Col >
            </Row >
            <Row>
              <Col xl="12">
                <Card className="mt-3" style={{ height: 'fit-content' }}>
                  <CardHeader>Sales Information</CardHeader>
                  <CardBody>
                    <Row className="py-2 border-bottom">
                      <Col xl="4">Item & Description</Col>
                      <RequirePermission
                        module={MODULES_ENUM.ORDERS}
                        permission={PERMISSIONS_ENUM.CREATE}
                      >
                        <Col xl="3">Rate</Col>
                      </RequirePermission>
                      <Col xl="3">Ordered</Col>
                      <RequirePermission
                        module={MODULES_ENUM.ORDERS}
                        permission={PERMISSIONS_ENUM.CREATE}
                      >
                        <Col xl="2">Amount</Col>
                      </RequirePermission>
                    </Row>
                    {itemsData &&
                      itemsData.map((item, index) => {
                        const itemTitle = item?.itemId?.title || '';
                        const itemDescription = item?.alternateItemTitle || item?.itemId?.title
                        return (
                          <Row
                            key={index}
                            className="py-2 border-bottom align-items-center"
                          >
                            <Col xl="4">
                              <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                                <h6
                                  style={{
                                    margin: 0,
                                    fontSize: '14px',
                                    paddingTop: '3px',
                                  }}
                                >
                                  {itemTitle}
                                </h6>
                              </RequireUserType>
                              <span>
                                {itemDescription}
                              </span>
                            </Col>
                            <RequirePermission
                              module={MODULES_ENUM.ORDERS}
                              permission={PERMISSIONS_ENUM.CREATE}
                            >
                              <Col xl="3">
                                <h6 className="m-0">
                                  {formatNumberWithCommasAndDecimal(
                                    item.unitPrice,
                                  )}
                                </h6>
                              </Col>
                            </RequirePermission>
                            <Col xl="3">
                              {item.quantity}&nbsp;{item.itemUnit}
                            </Col>
                            <RequirePermission
                              module={MODULES_ENUM.ORDERS}
                              permission={PERMISSIONS_ENUM.CREATE}
                            >
                              <Col xl="2">
                                <h6 className="m-0">
                                  {formatNumberWithCommasAndDecimal(
                                    item.unitPrice * item.quantity,
                                  )}
                                </h6>
                              </Col>
                            </RequirePermission>
                          </Row>
                        );
                      })}
                  </CardBody >
                </Card >
              </Col >
              </Row >
            <Row>
               <Col xl="8">
                <Card className="mt-3">
                  <CardHeader>Terms & Conditions</CardHeader>
                  <CardBody>
                    {orderInfo.terms ? (
                      <div style={{
                        padding: "30px 20px 20px", fontSize: "14px", lineHeight: "1.6", color: "#172554", fontFamily: "inherit",
                      }}>
                        {orderInfo.terms.trim()
                          .split(/\n(?=\s*\d+\.)/) 
                          .map((term, index) => ( 
                          <div key={index} 
                            style={{ display: "flex", alignItems: "flex-start", marginBottom: "8px", }} 
                          > 
                        <span style={{ minWidth: "25px", fontWeight: "500", }} > 
                          {term.match(/^\s*(\d+\.)/)?.[1]} 
                        </span> 
                        <span> {term.replace(/^\s*\d+\.\s*/, "")} </span> 
                        </div> 
                      ))} 
                      </div> 
                      ) : (
                      <span style={{ color: 'grey' }}>
                        No Terms & Conditions
                      </span>
                    )}
                  </CardBody >
                </Card >
              </Col >
              <RequirePermission
                module={MODULES_ENUM.ORDERS}
                permission={PERMISSIONS_ENUM.CREATE}
              >
                <Col xl="4">
                  <Card className="mt-3">
                    <CardHeader>Order Info</CardHeader>
                    <CardBody
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <h5
                          className="mb-0"
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                          <span>Sub Total :</span>
                          <span>{formatNumberWithCommasAndDecimal(orderInfo.totalAmount)}</span>
                        </h5>
                        <div style={{ fontSize: '0.7rem' }}>
                          Total Quantity: {orderInfo.totalQuantity}
                        </div>
                        <hr />
                        {getTaxRows(orderInfo).map((row) => (
                          <React.Fragment key={row.label}>
                            <h5
                              className="mb-0"
                              style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                              <span>{row.label} :</span>
                              <span>{formatNumberWithCommasAndDecimal(row.value)}</span>
                            </h5>
                            <hr />
                          </React.Fragment>
                        ))}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </RequirePermission>           
            </Row >
          </div >
        </Row >
      </div >
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(PurchaseOrderDetails);
